import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import {
  type ChartingNoncomplianceState,
  type GetChartingNoncompliancesResponse,
  GetChartingNoncompliancesResponseSchema,
} from "@src/appV2/Charting/api/schema";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

interface GetChartingNoncompliancesParams {
  workplaceId?: string;
  workerId: string;
  state?: ChartingNoncomplianceState[];
}

export function useGetChartingNoncompliances(
  params: GetChartingNoncompliancesParams,
  options: UseGetQueryOptions<GetChartingNoncompliancesResponse> = {}
) {
  const { workplaceId, workerId, state } = params;
  const filter = {
    ...(isDefined(workplaceId) && { "workplace.id": workplaceId }),
    ...(isDefined(state) && { state: state.join(",") }),
  };

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/charting-noncompliances`,
    queryParams: { filter },
    responseSchema: GetChartingNoncompliancesResponseSchema,
    meta: { logErrorMessage: APP_V2_APP_EVENTS.GET_CHARTING_NONCOMPLIANCES_FAILURE },
    ...options,
  });
}
